var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-panel-filters',{attrs:{"filter":_vm.filter,"page":_vm.page,"status":_vm.status},on:{"setStatus":_vm.setStatus}}),_c('demo-requests-table',{attrs:{"demoRequests":_vm.demoRequests,"totalPages":_vm.totalPages,"page":_vm.page,"status":_vm.status},on:{"setPage":_vm.setPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }